const MAX_IMAGE_SIZE = 5 * 1024 * 1024; // 5MB
const MAX_PDF_SIZE = 10 * 1024 * 1024; // 10MB

const ALLOWED_IMAGE_TYPES = ['image/jpeg', 'image/png', 'image/webp', 'image/gif'];
const ALLOWED_PDF_TYPES = ['application/pdf'];

export function validateImageFile(file) {
  if (!file) return 'No file selected';
  if (!ALLOWED_IMAGE_TYPES.includes(file.type)) {
    return 'Only JPEG, PNG, WebP, and GIF images are allowed';
  }
  if (file.size > MAX_IMAGE_SIZE) {
    return `Image must be under ${MAX_IMAGE_SIZE / 1024 / 1024}MB (yours is ${(file.size / 1024 / 1024).toFixed(1)}MB)`;
  }
  return null;
}

export function validatePdfFile(file) {
  if (!file) return 'No file selected';
  if (!ALLOWED_PDF_TYPES.includes(file.type)) {
    return 'Only PDF files are allowed';
  }
  if (file.size > MAX_PDF_SIZE) {
    return `PDF must be under ${MAX_PDF_SIZE / 1024 / 1024}MB (yours is ${(file.size / 1024 / 1024).toFixed(1)}MB)`;
  }
  return null;
}
